import canUseDOM from './canUseDOM'

// ponytail: SERVER_URL is a runtime env (NOT NEXT_PUBLIC), so it's read at
// container start — when the entrypoint's `generate` prerender runs — rather than
// baked at build. Lets the same image serve any domain; the value lives only in
// the VPS .env (DOMAIN). Client code derives the URL from window.location instead.
export const getServerSideURL = () => {
  return (
    process.env.SERVER_URL ||
    (process.env.VERCEL_PROJECT_PRODUCTION_URL
      ? `https://${process.env.VERCEL_PROJECT_PRODUCTION_URL}`
      : 'http://localhost:3000')
  )
}

export const getClientSideURL = () => {
  if (canUseDOM) {
    const protocol = window.location.protocol
    const domain = window.location.hostname
    const port = window.location.port

    return `${protocol}//${domain}${port ? `:${port}` : ''}`
  }

  if (process.env.VERCEL_PROJECT_PRODUCTION_URL) {
    return `https://${process.env.VERCEL_PROJECT_PRODUCTION_URL}`
  }

  return process.env.SERVER_URL || ''
}
